<template>
  <v-container>
    <v-row>
      <v-col>
        <v-card-title>Identity</v-card-title>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-card class="pa-4">
                <div class="mb-2">
                  <v-card-title>Name</v-card-title>
                  <v-card-text>
                    <v-text-field label="Name" v-model="name"></v-text-field>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn @click="saveChanges">Apply</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-card-title>Location</v-card-title>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-card class="pa-4">
                <div class="mb-2">
                  <v-card-title>Location</v-card-title>
                  <v-card-text>
                    <v-combobox v-model="locationMode" :items="locationModeItems"
                      label="Location"></v-combobox>
                  </v-card-text>
                  <div v-show="locationMode == locationModeItems[1]">
                    <DeviceLocation :device="device" />
                  </div>
                  <v-card-actions class="justify-end">
                    <v-btn @click="saveLocation">Apply</v-btn>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
        <v-card-title>Danger Zone</v-card-title>
        <v-container fluid>
          <v-row>
            <v-col>
              <v-card class="card-red-border pa-4">
                <div class="mb-2">
                  <v-card-title>Restart app</v-card-title>
                  <v-card-text>
                    Kills the app and attempts to auto-start the app and
                      re-connect to the manager. You may lose the connection.
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn class="red--text" @click="snackbar = true">RESTART</v-btn>
                    <v-snackbar v-model="snackbar">
                      Not yet implemented.
                      <v-btn @click="snackbar = false">Close</v-btn>
                    </v-snackbar>
                  </v-card-actions>
                </div>
                <v-divider></v-divider>
                <div class="mb-2">
                  <v-card-title>Reboot device</v-card-title>
                  <v-card-text>
                    Performs a hardware reboot and attempts to auto-start
                      the app and re-connect to the manager. You may lose the connection.
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn class="red--text" @click="snackbar = true">REBOOT</v-btn>
                    <v-snackbar v-model="snackbar">
                      Not yet implemented.
                      <v-btn @click="snackbar = false">Close</v-btn>
                    </v-snackbar>
                  </v-card-actions>
                </div>
                <v-divider></v-divider>
                <div>
                  <v-card-title>Remove device</v-card-title>
                  <v-card-text>
                    Permanently removes this device from your account, but does
                      not delete content that is already captured. You will lose
                      remote control to the device.
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn class="red--text" @click.stop="removeDialog = true">REMOVE</v-btn>
                    <v-dialog max-width="300" v-model="removeDialog">
                      <v-card>
                        <v-card-title class="headline">Remove device</v-card-title>
                        <v-card-text>
                          Are you sure you want to remove this device? This action cannot be undone.
                          You will need to re-register the hardware
                          as a new device to gain control again.
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn @click="removeDialog = false">Cancel</v-btn>
                          <v-btn color="red" @click="removeDevice">Remove</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </v-card-actions>
                </div>
                <v-divider></v-divider>
                <div>
                  <v-card-title>Register device</v-card-title>
                  <v-card-text>
                    <p>
                    If you uninstall and then reinstall the LiveSYNC app on your device,
                    it must be registered again.
                    <br><br>Instead of registering it as a new device,
                    click REGISTER AGAIN button to show a QR code that
                    allows registering it as the same instance.
                    </p>
                  </v-card-text>
                  <v-card-actions class="justify-end">
                    <v-btn class="red--text"
                    @click.stop="resetDeviceAuthorization">REGISTER AGAIN</v-btn>
                    <v-dialog v-if="code" max-width="500" v-model="reAuthorizeDevice">
                      <AuthorizeDeviceDialog
                        :id="device.id"
                        :code="code"
                        :reAuthorizeDevice.sync="reAuthorizeDevice"/>
                    </v-dialog>
                  </v-card-actions>
                </div>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* eslint no-fallthrough: "off" */
import gql from 'graphql-tag';
import DeviceLocation from '@/components/Device/DeviceLocation.vue';
import AuthorizeDeviceDialog from '@/components/Device/AuthorizeDeviceDialog.vue';
import { v4 as uuidv4 } from 'uuid';

const UPDATE_DEVICE_PROPERTIES = gql`
mutation device_update_properties($id: String!, $name: String) {
  update_devices_by_pk(
    pk_columns: { id: $id },
    _set: {
      name: $name,
    }
  ) {
    name
  }
}
`;

const UPDATE_DEVICE_LOCATION = gql`
mutation update_device_location($id: String!, $location: geometry!) {
  update_devices_by_pk(
    pk_columns: { id: $id },
    _set: {
      location: $location
    }
  ) {
    id
    location
  }
}
`;

const REMOVE_DEVICE = gql`
mutation remove_device($id: String!) {
  delete_devices_by_pk(id: $id) {
    id
  }
}
`;
export default {
  name: 'DeviceConfiguration',
  data() {
    return {
      removeDialog: false,
      name: this.device.name,
      locationMode: 'Auto',
      locationModeItems: ['Auto', 'Manual'],
      snackbar: false,
      reAuthorizeDevice: false,
      code: null,
    };
  },
  props: {
    device: {
      type: Object,
      required: true,
    },
  },
  components: {
    DeviceLocation,
    AuthorizeDeviceDialog,
  },
  methods: {
    resetDeviceAuthorization() {
      this.code = uuidv4();
      this.reAuthorizeDevice = true;
    },
    saveChanges() {
      const {
        name,
      } = this;
      const { id } = this.device;

      const variables = {
        id,
        name,
      };

      this.$apollo.mutate({
        mutation: UPDATE_DEVICE_PROPERTIES,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_devices_by_pk } }) => {
          // Read the data from our cache for this query.
          // eslint-disable-next-line
          // TODO error handling what if mutation doesn't work
        },
      });
    },
    saveLocation() {
      // save new location
      const { id, location } = this.device;

      const variables = {
        id,
        location,
      };

      this.$apollo.mutate({
        mutation: UPDATE_DEVICE_LOCATION,
        variables,
        // eslint-disable-next-line
        update: (cache, { data: { update_devices } }) => {
          // TODO error handling what if mutation doesn't work
        },
      });
    },
    removeDevice() {
      this.removeDialog = false;
      const { id, type } = this.device;

      let route = null;
      switch (type) {
        case 'camera':
          route = { name: 'Cameras' };
          break;
        case 'mobile':
          route = { name: 'Mobiles' };
          break;
        case 'headset':
          route = { name: 'Headsets' };
          break;
        default:
          console.error('device type unknown');
      }
      const variables = {
        id,
      };
      // TODO error handling what if mutation doesn't work
      this.$apollo.mutate({
        mutation: REMOVE_DEVICE,
        variables,
      })
        .then((/* data */) => {
          console.log('device removed');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          if (route) {
            this.$router.push(route);
          }
        });
    },
  },
};
</script>
<style scoped>
.card-red-border {
  border: 1px solid red !important;
}
</style>
